import { dispatch } from 'app/store/configureStore';
import { openATM } from '../../base/effects/openATM';
import { closeUpdatesPanel } from '../../base/effects/closeUpdatesPanel';

export const onOpenATM = () => {
    dispatch(closeUpdatesPanel());
    setTimeout(() => dispatch(openATM()), 100);
};
